<template>
  <div class="patient-view overview" :key="patient.id">
    <ScheduleCard :patient="patient"> </ScheduleCard>
    <SymptomCard :patient="patient"> </SymptomCard>
    <VitalCard :patient="patient"> </VitalCard>
    <ActivityCard :patient="patient"> </ActivityCard>
    <LifestyleCard :patient="patient"> </LifestyleCard>
    <MedicationCard :patient="patient"> </MedicationCard>
    <ArticleCard :patient="patient"> </ArticleCard>
  </div>
</template>

<script>
import PatientView from ".";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "patient-overview",
  extends: PatientView,

  methods: {
    ...mapActions("provider", ["getPatientOverview"]),
  },
};
</script>
